var map = {
	"./bscTestnet.ts": [
		31140,
		1140
	],
	"./common/index.ts": [
		32368,
		2368
	],
	"./eth.ts": [
		31029,
		1029
	],
	"./goerli.ts": [
		62796,
		2796
	],
	"./index.ts": [
		71218
	],
	"./modeTestnet.ts": [
		22537,
		2537
	],
	"./priceHelperLps/1.ts": [
		9762,
		9762
	],
	"./priceHelperLps/42161.ts": [
		97240,
		7240
	],
	"./priceHelperLps/5.ts": [
		50167,
		167
	],
	"./priceHelperLps/56.ts": [
		5363,
		5363
	],
	"./priceHelperLps/59144.ts": [
		53095,
		3095
	],
	"./priceHelperLps/8453.ts": [
		997,
		997
	],
	"./priceHelperLps/97.ts": [
		85133,
		5133
	],
	"./priceHelperLps/getFarmsPriceHelperLpFiles.ts": [
		8672,
		8672
	],
	"./v3/index.ts": [
		39656,
		634
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 60092;
module.exports = webpackAsyncContext;